import {
  Component,
  HostBinding,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import {
  getTranslatedMenuItem,
  getTranslatedMenuItems,
} from '../../../../common-shared/config';

import { TranslateService } from '@ngx-translate/core';
import { ApiRequestBuilder, ApiService } from '../../../../common-shared/api';
import {
  Environment,
  EnvironmentApp,
  EnvironmentBot,
  EnvironmentDesktopFlow,
  EnvironmentFlow,
  TenantComplianceForm,
  TenantComplianceFormEntityType,
  User,
} from '../../../../../../backend-core-lib/app/common-shared/account/models';
import {
  SimplifiedTableColumnDef,
  SimplifiedTableRowActionEvent,
  SimplifiedTableSettings,
} from '../../../../common-shared/simplified-table';
import { cloneDeep, find, findIndex, flow } from 'lodash';

import { NotificationsService } from '../../../../common-shared/notifications';
import { SessionService } from '../../../../common-shared/session';
import { hasUserAdminAccessToEnvironmentEntity } from '../../../../../../backend-core-lib/app/common-shared/account/utils/has-user-admin-access-to-environment-entity';
import { ActivatedRoute } from '@angular/router';

import {
  EntityCommonDataInfoItem,
  EntityCommonPreferencesGroup,
  EntityCommonTable,
} from '../../../../common-shared/impliancy/types/entity-info-types';
import {
  entityTableComplianceExtraColumnDefs,
  entityTableNoComplianceExtraColumnDefs,
} from '../../../../common-shared/impliancy/components/entity-overview/config/entity-table.config';
import { EnvironmentTable } from '../../../../app/routes/environments/types/types';
import {
  environmentsOverviewBreadcrumbsConfig,
  environmentsOverviewTableSettings,
} from '../../../../app/routes/environments/config';
import { getComplianceStatus } from '../../../../app/shared';
import { homeBreadcrumbsConfig } from '../../../../app/navigation/config';
import { delay } from '../../../utils';
import { environment } from '../../../../environments/environment';

interface EnvironmentToSyncInfo {
  uid: string;
  name: string;
}

@Component({
  selector: 'entity-overview',
  templateUrl: './entity-overview.component.html',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class EntityOverviewComponent implements OnInit {
  @HostBinding('class')
  readonly cssClass = 'entity-overview  page-container';

  @Input()
  breadcrumbsHomeConfig!: MenuItem; // homeBreadcrumbsConfig

  @Input()
  breadcrumbsItemsConfig!: MenuItem[]; // environmentsOverviewBreadcrumbsConfig

  @Input()
  preferencesGroups!: EntityCommonPreferencesGroup[];

  @Input()
  dataItems!: EntityCommonDataInfoItem[];

  @Input()
  overviewBaseColumns!: SimplifiedTableColumnDef[];

  @Input()
  tableSettings!: SimplifiedTableSettings; // environmentsOverviewTableSettings

  @Input()
  entityType!: TenantComplianceFormEntityType;

  @Input()
  sidebarOptions = ['overview', 'preferences', 'compliance'];

  breadcrumbsItems: MenuItem[] = [];
  breadcrumbsHome!: MenuItem;

  isLoading = false;
  drawerSidebarVisible = false;

  toResyncEnvironments: EnvironmentToSyncInfo[] = [];
  environments: Environment[] = [];
  allEntities: EntityCommonTable[] = [];
  selectedEntity?: EntityCommonTable;
  selectedEnvironmentUid?: string;

  columnDefs!: SimplifiedTableColumnDef[];

  isComplianceDefined = false;
  complianceForms: TenantComplianceForm[] = [];

  waitSyncEnvMins = environment.waitBeforeEnvSyncMins;
  resyncingEnvironments = false;
  processedRouteAction = false;

  constructor(
    public translateService: TranslateService,
    public apiService: ApiService,
    private notificationsService: NotificationsService,
    private sessionService: SessionService,
    private activatedRoute: ActivatedRoute,
  ) {}
  ngOnInit() {
    this.initData(!this.sessionService.areEnvironmentsSynced());
    this.initBreadcrumbs();
    this.translateService.onLangChange.subscribe((lang: string) => {
      this.initBreadcrumbs();
    });
  }

  async initData(forceSync = false): Promise<void> {
    this.isLoading = true;

    await this.checkComplianceFormDefined();

    /*if (forceSync) {
      const syncRequest = new ApiRequestBuilder('syncEnvironment')
        .replaceUrl({ entityType: this.entityType, environmentUid:  })
        .showLoading()
        .build();
      await this.apiService.callApi(syncRequest);
      this.sessionService.setEnvironmentsSynced(true);
    }*/

    try {
      const sessionRequest = new ApiRequestBuilder('getEnvironments')
        .replaceUrl({ entityType: this.entityType })
        .build();
      const resultApi = await this.apiService.callApi(sessionRequest);
      console.log(resultApi);
      if (!resultApi || resultApi.status === 'error') {
        this.allEntities = [];
        return resultApi.data || 'ServerUnreachable';
      }
      await this.processEnvironmentsResult(resultApi.data);
    } catch (e) {
      this.isLoading = false;
    }

    /*this.environments = (resultApi.data || []).map((entry: Environment) => {
      return this.getEntityForTable(entry);
    });*/
    console.log(this.environments);

    const routeEntityId = (this.activatedRoute?.snapshot?.queryParams as any)
      ?.entityId;
    if (routeEntityId && !this.processedRouteAction) {
      this.processedRouteAction = true;
      const foundEntity = find(this.allEntities, { uid: routeEntityId });
      if (foundEntity) {
        this.onRowAction({
          dataItem: foundEntity,
          actionId: 'info',
        });
      }
    }
    this.doResyncEnvironments().finally();
  }

  async doResyncEnvironments(): Promise<void> {
    if (this.resyncingEnvironments || !this.toResyncEnvironments?.length) {
      return;
    }

    for (
      let indexEnv = 0;
      indexEnv < this.toResyncEnvironments?.length;
      indexEnv++
    ) {
      const thisEnv = this.toResyncEnvironments[indexEnv];
      try {
        this.notificationsService.addProgressNotification(
          this.translateService.instant(
            'entity.overview.messages.syncingEnvironment',
          ),
          `${thisEnv.name} [${indexEnv + 1}/${this.toResyncEnvironments?.length}]`,
        );
        // await delay(2000);
        const syncRequest = new ApiRequestBuilder('syncEnvironment')
          .replaceUrl({
            environmentUid: thisEnv.uid,
            entityType: this.entityType,
          })
          .build();
        await this.apiService.callApi(syncRequest);
      } catch (e) {}
    }
    this.notificationsService.removeProgressNotification();

    try {
      this.isLoading = true;
      const sessionRequest = new ApiRequestBuilder('getEnvironments')
        .replaceUrl({ entityType: this.entityType })
        .build();
      const resultApi = await this.apiService.callApi(sessionRequest);
      if (!resultApi || resultApi.status === 'error') {
        this.allEntities = [];
        return resultApi.data || 'ServerUnreachable';
      }
      await this.processEnvironmentsResult(resultApi.data);
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
    }
  }

  async processEnvironmentsResult(environments: Environment[]): Promise<void> {
    this.environments = environments || [];
    const newEntities: EntityCommonTable[] = [];
    if (!this.resyncingEnvironments) {
      this.toResyncEnvironments = [];
    }

    const currentTime = Math.floor(Date.now());
    if (this.entityType === 'ENVIRONMENT') {
      (environments || []).map((entry: Environment) => {
        newEntities.push(this.getEntityForTable(entry, entry));
      });
    } else {
      (environments || []).forEach((environment: Environment) => {
        if (
          !this.resyncingEnvironments &&
          !!environment.data?.flags.enableInventory &&
          (environment.lastSyncedAt || 0) <
            currentTime - this.waitSyncEnvMins * 60 * 1000
        ) {
          const toPush = {
            uid: environment.uid,
            name: (
              environment.metadata.displayName ||
              environment.metadata.name ||
              ''
            ).substr(0, 40),
          };
          if (toPush.name.length >= 39) {
            toPush.name = toPush.name + '...';
          }
          this.toResyncEnvironments.push(toPush);
        }
        switch (this.entityType) {
          case 'APP':
            (environment.apps || []).forEach((app: EnvironmentApp) => {
              newEntities.push(this.getEntityForTable(app, environment));
            });
            break;
          case 'FLOW':
            (environment.flows || []).forEach((flow: EnvironmentFlow) => {
              newEntities.push(this.getEntityForTable(flow, environment));
            });
            break;
          case 'DESKTOPFLOW':
            (environment.desktopFlows || []).forEach(
              (desktopFlow: EnvironmentDesktopFlow) => {
                newEntities.push(
                  this.getEntityForTable(desktopFlow, environment),
                );
              },
            );
            break;
          case 'BOT':
            (environment.bots || []).forEach((bot: EnvironmentBot) => {
              newEntities.push(this.getEntityForTable(bot, environment));
            });
            break;
        }
      });
    }

    this.allEntities = newEntities;
    this.isLoading = false;
    console.log(this.toResyncEnvironments);
  }
  getEntityForTable(
    entity:
      | Environment
      | EnvironmentApp
      | EnvironmentFlow
      | EnvironmentDesktopFlow
      | EnvironmentBot,
    environment: Environment,
  ): EntityCommonTable {
    const enableCompliance = environment.data?.flags?.enableCompliance ?? false;
    return {
      ...entity,
      __complianceStatus: !enableCompliance
        ? 'YES'
        : getComplianceStatus(
            entity.filledCompliance || [],
            this.complianceForms,
          ),
      __environmentName: environment.metadata.name,
      __environmentDisplayName: environment.metadata.displayName,
      __enableCompliance: enableCompliance,
      __hasAdminRights: hasUserAdminAccessToEnvironmentEntity(
        environment,
        this.entityType,
        entity.uid,
        this.sessionService.getUser() as User,
      ), // Only get
    };
  }
  async checkComplianceFormDefined(): Promise<void> {
    const getAllFormsRequest = new ApiRequestBuilder(
      'getEntityTypeAllComplianceForms',
    )
      .replaceUrl({
        entityType: this.entityType,
      })
      .build();

    const allFormsResponse = await this.apiService.callApi(getAllFormsRequest);
    if (allFormsResponse.status === 'success' && allFormsResponse.data) {
      this.complianceForms = allFormsResponse.data;
      this.isComplianceDefined = !!find(this.complianceForms, {
        isActive: true,
      });
    }
    this.columnDefs = this.isComplianceDefined
      ? [...this.overviewBaseColumns, ...entityTableComplianceExtraColumnDefs]
      : [
          ...this.overviewBaseColumns,
          ...entityTableNoComplianceExtraColumnDefs,
        ];
  }

  initBreadcrumbs(): void {
    console.log(this.breadcrumbsItems);
    this.breadcrumbsItems = getTranslatedMenuItems(
      this.breadcrumbsItemsConfig,
      this.translateService,
    );
    this.breadcrumbsHome = getTranslatedMenuItem(
      this.breadcrumbsHomeConfig,
      this.translateService,
    );
  }
  onRowAction(event: SimplifiedTableRowActionEvent): void {
    console.log(event);
    switch (event.actionId) {
      case 'info':
        const env = this.getEnvForEntity(event.dataItem);
        this.selectedEnvironmentUid = (env as Environment).uid;
        this.selectedEntity = event.dataItem;

        this.drawerSidebarVisible = true;
        break;
    }
  }
  async onTableAction(actionId: string): Promise<void> {
    switch (actionId) {
      case 'refresh':
        console.log('Do refresh');
        await this.initData(true);
        break;
    }
  }

  getEnvForEntity(entity: EntityCommonTable): Environment | undefined {
    if (this.entityType === 'ENVIRONMENT') {
      return entity;
    }
    for (let index = 0; index < this.environments.length; index++) {
      const thisEnv = this.environments[index];
      let foundEntity: EntityCommonTable = undefined;
      switch (this.entityType) {
        case 'APP':
          foundEntity = find(thisEnv.apps || [], { uid: entity.uid });
          break;
        case 'FLOW':
          foundEntity = find(thisEnv.flows || [], { uid: entity.uid });
          break;
        case 'DESKTOPFLOW':
          foundEntity = find(thisEnv.desktopFlows || [], { uid: entity.uid });
          break;
        case 'BOT':
          foundEntity = find(thisEnv.bots || [], { uid: entity.uid });
          break;
      }
      if (foundEntity) {
        return thisEnv;
      }
    }
    return undefined;
  }

  onEntityUpdated(event: EntityCommonTable): void {
    console.log('onEnvironmentUpdated');
    console.log(event);
    const foundIndex = findIndex(this.allEntities, (env: EntityCommonTable) => {
      return env.uid === event.uid;
    });
    if (foundIndex >= 0) {
      const updatedEnv = this.getEntityForTable(
        cloneDeep(event),
        this.getEnvForEntity(event) as Environment,
      );
      this.allEntities.splice(foundIndex, 1, updatedEnv);
      this.allEntities = cloneDeep(this.allEntities);
      if (this.selectedEntity?.uid === updatedEnv?.uid) {
        this.selectedEntity = updatedEnv;
      }
    }
  }

  getWikiHelOverviewId(): string {
    return `${this.entityType.toUpperCase()}S--OVERVIEW`; // Ex: ENVIRONMENTS-OVERVIEW
  }
}
